import { ChangeRequestState, ChangeRequestType, VendorChangeRequestEntityType } from '../../types';
import { EditableEntity } from '../EditableEntity';
import { VendorEntity } from './VendorEntity';

export class VendorChangeRequestEntity extends EditableEntity {
  vendor: VendorEntity;
  state: ChangeRequestState;
  type: ChangeRequestType;
  entityType: VendorChangeRequestEntityType;
  reviewedDate: Date | null;
  reviewedBy: string | null;

  constructor(entity?: VendorChangeRequestEntity) {
    super(entity);
    if (entity) {
      Object.assign(this, { ...entity });
    }
  }

  get isDeleted() {
    return this.type === ChangeRequestType.Archive;
  }
}
